import { Box, Paper, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ObservationTable from "../Observation/ObservationTable";
import Scrollbar from "./Scrollbar";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CommonGate from "./Gate";
// import { store } from '../../redux/store';
// import * as patientActions from '../../redux/actions/patientActions';
// import { useParams } from "react-router-dom";


const paperStyle = {
    sx: {
        borderRadius: '6.9px',
        width: {
            xs: "95%",
            sm: "100%",
            md: "100%",
            lg: "100%",
        },
        marginBottom: '15px',
        boxShadow: 'none',
    },
};

const Observation = () => {
    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // const { consultationId } = useParams();

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                setTableHeight(entry.contentRect.height);
            }
        });
        if (tableRef.current) {
            observer.observe(tableRef.current);
        }
        return () => {
            if (tableRef.current) {
                observer.unobserve(tableRef.current);
            }
        };
    }, []);

    // const refreshObervation = async () => {
    //     store.dispatch(patientActions.getPatientConsultationDetailsRequestAction(consultationId));
    // };

    const renderContent = () => {
        return <Box sx={{ height: { xs: 'auto', md: '77vh', lg: "78vh", xl: '78vh' }, }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <CommonGate showComplaint={false} refreshObervation={true} />
                <Paper {...paperStyle} sx={{
                    ...paperStyle.sx,
                    height: tableHeight ? `${tableHeight + 32}px` : 'auto',
                }} >
                    <div ref={tableRef}>
                        <ObservationTable />
                    </div>
                </Paper>
            </Box>
        </Box>
    }

    return (
        isMobile ? renderContent() :
            <Scrollbar gridTemplate="auto / 1fr 14px" padding="0 1.2rem 1rem 0rem" scrollerPadding="0rem" scrollerWidth="12px">
                {renderContent()}
            </Scrollbar>
    );
};

export default Observation;


